import { memo } from 'react';
import Dialog from '@mui/material/Dialog';
import TextInformation from '../TextInformation/TextInformation';
import IconButton from '@mui/material/IconButton';
import { Row } from '../../theme/Styles';
import {
  Container,
  ContentContainer,
  StyledCloseIcon
} from './styles/FormModalStyles';

function FormModal({ children, title, open, onClose, conditionalClose, fullWidth, fullScreen, maxWidth = 'md', minHeight = '350px' }) {
  //conditionalClose - The modal doesn't close on backdrop click or close button click
  return (
    <Dialog
      open={open}
      onClose={conditionalClose ? null : onClose}
      onBackdropClick={conditionalClose ? null : onClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
      fullScreen={fullScreen}
      BackdropProps={{
        sx: {
          backdropFilter: 'blur(6px)',
          backgroundColor: 'rgba(3, 13, 57, 0.4)'
        }
      }}
      PaperProps={{
        sx: {
          borderRadius: '24px',
          boxShadow: '0 25px 50px -12px rgba(3, 13, 57, 0.2)',
          border: '1px solid rgba(226, 232, 240, 0.8)',
          overflow: 'visible',
          'body.admin-shell &': {
            boxShadow: 'none'
          }
        }
      }}
    >
      <Container maxWidth={maxWidth} minHeight={minHeight}>
        <ContentContainer >
          {
            !conditionalClose && (
              <IconButton 
                onClick={onClose} 
                sx={{ 
                  position: 'absolute',
                  right: '16px',
                  top: '16px',
                  zIndex: 10,
                  backgroundColor: '#F1F5F9',
                  borderRadius: '50%',
                  transition: 'all 0.25s ease-in-out',
                  width: '32px',
                  height: '32px',
                  '&:hover': {
                    backgroundColor: '#E2E8F0',
                    transform: 'rotate(90deg) scale(1.05)'
                  }
                }}
              >
                <StyledCloseIcon />
              </IconButton>
            )
          }
          <Row>
            {
              title ?
                <TextInformation title={title} />
                :
                <div style={{ width: '100%', height: title ? 'auto' : '0px' }} />
            }
          </Row>
          {
            children
          }
        </ContentContainer>
      </Container>
    </Dialog>
  );
}

export default memo(FormModal)